var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneratingResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 200,
    viewBox: "0 0 188 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nnztp7f9da",
    d: "M0 200h186V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.792 161.718 12.255.093-2.878 14.093s-1.532 3.105-4.039 3.198c-2.506.093-5.152-.834-5.245-1.159-.093-.324-.093-16.225-.093-16.225M28.939 96.91l-6.87-7.743s-.789-3.198 1.114-4.914c1.903-1.715 4.317-2.781 4.317-2.781l9.47 7.37-8.031 8.067zM152.43 11.393l-3.748-4.548a11.98 11.98 0 0 0-14.34-3.23 6.694 6.694 0 0 0-3.84 6.037v5.135c0 1.568.433 3.094 1.277 4.462l-3.892 12.247a.42.42 0 0 0 .277.527l10.804 3.306a.413.413 0 0 0 .37-.064.419.419 0 0 0 .17-.336v-6.057l2.836 2.467a3.22 3.22 0 0 0 2.906.706 3.21 3.21 0 0 0 2.254-1.963l1.775-4.496h1.632a.42.42 0 0 0 .418-.4l.237-4.993.958-8.488a.418.418 0 0 0-.093-.312",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.233 31.233s6.272.895 12.842 3.282c6.572 2.386-.896 26.546-.896 26.546l-15.829 19.09-41.215-7.755 45.098-41.163z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.545 79.555-36.133 45.928c-8.758 11.132-25.27 12.169-35.355 2.22l-25.08-26.87 16.724-17.3 15.93 9.146 21.503-20.283 42.411 7.159z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.644 80.714-7.603-7.593-18.725 18.7c-1.573 1.571 1 4.661 3.802 4.641l16.75-6.749s-2.67-6.187 5.776-9",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.443 80.513-5.43-5.424L3.288 93.79c-1.573 1.571-.214 3.45 2.19 3.033l16.257-6.974s-1.935-5.72 5.708-9.336",
    fill: "#6176F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.644 80.714-7.603-7.593-18.725 18.7c-1.573 1.571 1 4.661 3.802 4.641l16.75-6.749s-2.67-6.187 5.776-9z",
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.375 178.376v10.738h26.48c2.225 0 2.593-4.002.599-5.966l-16.624-7.057s-2.49 6.262-10.455 2.285",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.375 178.66v7.67h26.48c2.225 0 2.593-2.288.599-3.69l-16.434-6.552s-2.68 5.412-10.645 2.572",
    fill: "#6176F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.375 178.376v10.738h26.48c2.225 0 2.593-4.002.599-5.966l-16.624-7.057s-2.49 6.262-10.455 2.285zM27.644 80.714l10.473 8.187M21.869 89.713l7.488 8.335",
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.92 190.812h-47.528a17.293 17.293 0 0 1-10.186-3.317l-4.43-3.228",
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.02 190.812h47.527c3.662 0 7.229-1.161 10.186-3.317l4.43-3.228M112.886 195.882a3.284 3.284 0 0 1-3.286 3.282 3.283 3.283 0 0 1-3.285-3.282 3.283 3.283 0 0 1 3.285-3.28 3.283 3.283 0 0 1 3.286 3.28zM163.659 195.882a3.284 3.284 0 0 1-3.286 3.282 3.283 3.283 0 0 1-3.284-3.282 3.283 3.283 0 0 1 3.284-3.28 3.283 3.283 0 0 1 3.286 3.28z",
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.545 79.555 29.39 29.352a19.915 19.915 0 0 1 5.417 18.2l-7.33 34.773h-25.685v-34.003l-26.88-16.704 25.088-31.618z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m97.353 112.366 10.752-14.317"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m124.374 178.082-.139-17.102M134.911 175.857l2.785-14.325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.97 77.315c-7.573-4.89-32.737-5.218-37.365-5.237l5.67-10.746a.419.419 0 0 0-.146-.549l-17.954-11.409a.417.417 0 0 0-.534.072c-.045.048-4.547 4.998-8.318 11.035-5.123 8.205-6.525 14.411-4.168 18.449 5.391 9.234 39.032 11.113 42.12 11.266.681.756 3.973 4.171 7.187 3.685 0 .002 0 .003-.002.005-.05.35-.255 2.167.774 3.523.575.758 1.416 1.213 2.5 1.353.286.037.553.053.806.053.959 0 1.68-.258 2.24-.675a.412.412 0 0 0 .143.029h.016c2.753-.102 4.303-.668 5.189-1.503a.396.396 0 0 0 .176.08c.164.028.326.04.489.04 1.3 0 2.532-.861 3.425-2.038a.413.413 0 0 0 .354.433c.182.026.358.038.527.038 2.135-.001 3.336-1.9 3.756-3.785.704-3.16.743-9.194-6.885-14.12",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.347 52.898s20.033 12.563 21.52 15.723c1.486 3.16 10.713-17.442 8.119-26.192-1.781-6.013-1.132-9.182-11.624-9.131-10.491.05-18.015 19.6-18.015 19.6",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.883 11.52c-.3 1.085-1.785 1.624-3.318 1.202-1.531-.422-2.53-1.644-2.23-2.73.3-1.087 1.784-1.625 3.316-1.203 1.532.422 2.532 1.645 2.232 2.73M108.727 14.23c-.3 1.085-1.784 1.624-3.317 1.202-1.532-.422-2.53-1.644-2.231-2.73.3-1.086 1.785-1.624 3.317-1.202 1.532.421 2.531 1.644 2.231 2.73",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.623,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m97.964 11.36 2.813-10.19 9.932 2.735-2.813 10.19M100.541 4.474l9.395 2.587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.958 18.761c.349 1.072-.593 2.338-2.105 2.829-1.512.492-3.02.02-3.368-1.05-.35-1.071.592-2.338 2.104-2.83 1.511-.49 3.02-.02 3.369 1.051",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.623,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m78.103 19.134-3.275-10.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.95 49.727s-17.912 19.605-12.433 28.992c5.48 9.387 41.955 11.068 41.955 11.068s4.342 5.08 7.926 3.39",
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.904 61.137-5.992 11.358s29.668-.1 37.831 5.17c8.163 5.27 7.134 11.745 6.703 13.678-.43 1.933-1.65 3.723-3.816 3.424",
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.635 84.825c1.094 1.59 2.432 4.39 1.246 7.833-.727 2.115-2.67 3.985-4.507 3.675",
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.453 87.012s1.593 2.685 1.494 5.27c-.112 2.881.025 5.244-6.024 5.468",
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.476 88.876s2.463 3.207 1.792 5.692c-.586 2.166-1.395 4.176-4.48 3.778-3.087-.397-3.05-3.468-2.913-4.4.137-.931 2.017-1.764 2.614-.273M110.494 51.218c1.022-.992 7.467-10.44 12.843-14.317M135.47 19.19l-.549 2.733a3.598 3.598 0 0 0 1.168 3.42l6.53 5.68c1.475 1.284 3.779.722 4.497-1.095l1.879-4.761h1.915l.24-5.021.957-8.488-3.748-4.549a11.572 11.572 0 0 0-13.84-3.115 6.25 6.25 0 0 0-3.598 5.658v5.135a8.02 8.02 0 0 0 1.29 4.36l.026.043-3.95 12.433M118.711 13.81h35.072",
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.177 13.69c.003-.099.008-.198.008-.298 0-6.9-5.6-12.493-12.509-12.493-6.908 0-12.509 5.593-12.509 12.493 0 .1.006.2.008.299h25.002z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.575 10.974c-.041-.019-.081-.04-.123-.059-2.885-1.285-6.344.177-7.723 3.266-1.38 3.09-.16 6.635 2.726 7.92.042.02.084.036.127.053l4.993-11.18z",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.078 19.631c.03.578.394 1.03.81 1.007.417-.022.73-.508.7-1.087-.032-.578-.395-1.029-.81-1.007-.418.022-.731.51-.7 1.087",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M148.575 16.628h-4.13M147.245 28.241c-1.934.728-2.064-1.835-2.064-1.835M139.09 28.006v6.923"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "haui0uswwb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nnztp7f9da"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#haui0uswwb)",
    d: "M134.361 14.02h4.13V.835h-4.13z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6176F4",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#haui0uswwb)",
    d: "M134.361 14.02h4.13V.835h-4.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.217 17.023a5.787 5.787 0 0 1-5.79 5.783 5.787 5.787 0 0 1-5.791-5.783 5.787 5.787 0 0 1 5.79-5.783c3.199 0 5.791 2.59 5.791 5.783",
    fill: "#FFF",
    mask: "url(#haui0uswwb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.217 17.023a5.787 5.787 0 0 1-5.79 5.783 5.787 5.787 0 0 1-5.791-5.783 5.787 5.787 0 0 1 5.79-5.783c3.199 0 5.791 2.59 5.791 5.783z",
    stroke: "#6176F4",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#haui0uswwb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.87 17.023a2.441 2.441 0 0 1-2.443 2.44 2.441 2.441 0 0 1-2.443-2.44 2.441 2.441 0 0 1 2.443-2.44 2.441 2.441 0 0 1 2.443 2.44",
    fill: "#FFF",
    mask: "url(#haui0uswwb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.87 17.023a2.441 2.441 0 0 1-2.443 2.44 2.441 2.441 0 0 1-2.443-2.44 2.441 2.441 0 0 1 2.443-2.44 2.441 2.441 0 0 1 2.443 2.44z",
    stroke: "#6176F4",
    strokeWidth: 1.673,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#haui0uswwb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080717",
    mask: "url(#haui0uswwb)",
    d: "m141.155 34.462-13.825-6.276-2.306 2.988 13.797 7.143z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratingResult);
export default __webpack_public_path__ + "static/media/generating-result.7b309c7ca49666dae37e743cd1e9c650.svg";
export { ForwardRef as ReactComponent };